// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"f468b46f","583":"88e972b4","983":"8555c827"}[chunkId] + ".chunk.js";
};